import React from 'react';
import { SiteProperty } from 'volto-site-settings';

const BrandText = () => {
  const title = SiteProperty({
    property: 'site_title',
    defaultValue: 'io-studio',
    getValue: true,
  });

  const description = SiteProperty({
    property: 'site_subtitle',
    defaultValue: null,
    getValue: true,
  });

  return (
    <div className="brand-text">
      {title && <div className="brand-title">{title}</div>}
      {description && <div className="brand-description">{description}</div>}
    </div>
  );
};

export default BrandText;
